import React from "react";
import { connect } from "react-redux";
import Translated from "../../../components/Translated/Translated";

function PrintForm(props) {
	let formURL = props.APIUrl + "/emco_quotes/print";
	return (
		<form class="quote-nav-component" action={formURL} method="post" target="_blank">
			<input type="hidden" name="trendId" value={localStorage.getItem("trendId")} />
			<input type="hidden" name="password" value={localStorage.getItem("token")} />
			<input type="hidden" name="language" value={props.language} />
			<input type="hidden" name="project_id" value={props.projectId} />

			<button class="quote-nav-top-link">
				<div></div>
				<div><Translated section="Misc" label="print" /></div>
			</button>
		</form>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PrintForm);
